module.exports = __webpack_public_path__ + "img/smiling_face.e4e98263.gif";